import styled from 'styled-components'
import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import InternalError from 'errors/internal-error'
import NotFound from 'errors/not-found'
import LessonContent from 'class/lesson-content'
import CommentsSection from 'class/comment-section'
import LessonFullPath from 'class/navigation/lessons-full-path'
import FreeClass from 'class/free-class-banner'
import FirstOffer from 'class/first-offer'
import Navigation from 'components/navigation'
import UnlockClass from 'class/unlock-class'
import OpenGraph from 'common/open-graph'
import { useCourse } from 'querys/course'
import { useLesson, useLessons, useNeighborLessons } from 'querys/lesson'
import LessonVideo from 'class/video/lesson-video'
import LoadingState from 'common/loading-state'

const PrefetchReactions = styled.div`
  background: url(/images/sprites/like-blue-sprite.png), url(/images/sprites/wand-blue-sprite.png), url(/images/sprites/nogiveup-blue-sprite.png), url(/images/sprites/like-sprite.png), url(/images/sprites/wand-sprite.png), url(/images/sprites/nogiveup-sprite.png);
`

const LessonGrid = styled.div`
  padding-top: 72px;
  @media(min-width: 1024px) {
    padding-top: 0;
    display: grid;
    grid-template-columns: ${({ lessonsOpen }) => (lessonsOpen ? '280px 1fr' : '88px 1fr')};
    transition: 0.1s ease-in grid-template-columns;
    grid-template-areas: 'path content';
    .lesson-content {
      grid-area: content;
      max-height: calc(100vh - 72px);
      overflow: auto;
    }
  }
`

function Lesson({ courseSlug, lessonSlug }) {
  const [lessonsOpen, setLessonsOpen] = useState(false)
  const router = useRouter()
  const { data, isLoading: loadingLesson, error } = useLesson()
  const { isLoading: loadingLessons } = useLessons()
  const { data: course, isLoading: courseLoading } = useCourse()

  useNeighborLessons()

  useEffect(() => {
    if (window.matchMedia('(min-width: 1024px)').matches) {
      const pathSaved = window.localStorage.getItem('lessons-path')
      const preference = pathSaved ? JSON.parse(pathSaved) : true
      setLessonsOpen(preference)
    }
  }, [router.query.lesson_slug])

  if (loadingLesson || loadingLessons || courseLoading) return <LoadingState />

  if (error?.message === 'User Unauthorized') {
    router.push(`/login?next=${router.asPath}`)
    return null
  }
  if (error?.message === 'Not Found') return <NotFound />
  if (error?.message === 'Internal Error') return <InternalError />

  return (
    <>
      <OpenGraph
        title={data.title}
        url={`https://leonidasesteban.com/aprender/${courseSlug}/${lessonSlug}`}
        keyword={data.meta}
        description={data.meta}
        image={data.thumbnails ? data.thumbnails[1]?.link : ''}
      />
      {/* <Head>
        <Script src="https://www.youtube.com/iframe_api" defer />
      </Head> */}
      <Navigation noCountdown fullWidth />
      <UnlockClass />
      <LessonGrid lessonsOpen={lessonsOpen}>
        <div className="lesson-content">
          {course?.is_free ? (
            <FirstOffer />
          ) : null}
          <FreeClass />
          <LessonVideo />
          <LessonContent setLessonsOpen={setLessonsOpen} show={!lessonsOpen} />
          <CommentsSection show={!lessonsOpen} />
        </div>
        <LessonFullPath setLessonsOpen={setLessonsOpen} show={lessonsOpen} />
      </LessonGrid>
      <PrefetchReactions />
    </>
  )
}

Lesson.pageTheme = {
  background: 'var(--sky)',
  height: '100vh',
  overflow: 'hidden',
}

export default Lesson
